export default {
  SET_ADVERTISERS_LOADING: 'SET_ADVERTISERS_LOADING',
  SET_ADVERTISERS: 'SET_ADVERTISERS',
  SET_ALL_ADVERTISERS_LOADING: 'SET_ALL_ADVERTISERS_LOADING',
  SET_ALL_ADVERTISERS: 'SET_ALL_ADVERTISERS',
  SET_ERROR: 'SET_ERROR',
  SET_LOADING: 'SET_LOADING',
  SET_NETWORK_ACTIVITY: 'SET_NETWORK_ACTIVITY',
};
